import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    "show-file-list": true,
    "auto-upload": false,
    "on-change": _ctx.uploadDesignVariant
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        loading: _ctx.state.isLoading,
        size: "small",
        type: "default"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode("  " + _toDisplayString(_ctx.uploadName), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["on-change"]))
}